import { render, staticRenderFns } from "./TraningAndSupportSvg.vue?vue&type=template&id=dfb8627c&"
import script from "./TraningAndSupportSvg.vue?vue&type=script&lang=js&"
export * from "./TraningAndSupportSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports